/* ============================================================================
   face-scan-property.js — Kaufsperre und Lader des Face-Scans
   ----------------------------------------------------------------------------
   Geladen von snippets/face-scan-property.liquid, also nur auf Produkten mit
   Face-Scan (blocks/product-form.liquid: Einstellung `face_scan` und Metafeld
   `custom.face_width_formula`). Seit M10b ist der Face-Scan zweigeteilt
   (architektur §2.3):

     face-scan-property.js  diese Datei, laeuft beim Laden der Seite:
                            Kaufsperre, Sperre der Messknoepfe bei
                            ausverkaufter Variante, `test_id` — und der Lader.
     face-scan.js           die Messung (Popup-Schritte, Kamera, MediaPipe),
                            bis M10b face-scan-app.js und auf jeder
                            Face-Scan-Seite sofort geladen. Jetzt erst per
                            import(), wenn jemand den Face-Scan oeffnet oder
                            Zeiger bzw. Fokus auf einen Messknopf setzt.

   KAUFSPERRE (Entscheidung D-FACESCAN-LAZY)
   ---------------------------------------------------------------------------
   `Shopify.FaceScan.handleAtc` liest assets/product.js vor jedem Kauf. Ohne
   Messung: Hinweis unter dem Face-Scan, dorthin scrollen, Farbrahmen, kein
   Kauf. Die Funktion stand bis M10b woertlich so in face-scan-app.js; sie
   sucht ihre Knoten jetzt beim Aufruf statt beim Laden (dieselben Knoten:
   .face-scan-container ueberlebt jeden Variantenwechsel, PRESERVE_STATE in
   assets/product.js).

   LADEFEHLER
   ---------------------------------------------------------------------------
   Kommt diese Datei nicht an, zeigt das `onerror` am Skript-Tag den Hinweis
   sofort (wie bisher). Scheitert spaeter das Nachladen von face-scan.js,
   schliesst das Popup, derselbe Hinweis erscheint, und `handleAtc` wird
   entfernt — assets/product.js sperrt den Kauf dann mit dem Ladefehler statt
   mit „Bitte ermittle zuerst deine Gesichtsbreite“, genau wie frueher, wenn
   face-scan-app.js fehlte. Scheitert erst MediaPipe, bleibt alles wie bisher
   (Hinweis im Popup, face-scan.js).
   ========================================================================== */

const POPUP = "face-scan-app";

window.Shopify = window.Shopify || {};
window.Shopify.FaceScan = window.Shopify.FaceScan || {};

window.Shopify.FaceScan.handleAtc = function handleAtc(_triggerEl) {
  const faceWidthCheckbox = document.querySelector("#FaceWidthCheckbox");
  const faceScanContainer = document.querySelector(".face-scan-container");
  const hasMeasured = faceWidthCheckbox.classList.contains("measured");
  const measureWrapper = document.querySelector(".face-scan-controls");
  const isAnimating = measureWrapper.classList.contains("face-scan-erroring");

  if (!hasMeasured) {
    // NOTE(D4): Hinweistext neu auf Kundenwunsch (29.09.2026).
    // Hinweistext unter dem Face-Scan (snippets/face-scan-property.liquid).
    // Legacy hatte nur Scrollen und Farbrahmen — der Rahmen allein sagte
    // nicht, WAS fehlt. Bleibt stehen, bis gemessen wurde (confirmResult in
    // assets/face-scan.js).
    const requiredHint = faceScanContainer.querySelector("[data-face-scan-required]");
    if (requiredHint) requiredHint.hidden = false;

    if (isAnimating) {
      return false;
    }

    measureWrapper.scrollIntoView({ behavior: "smooth", block: "nearest" });
    measureWrapper.classList.add("face-scan-erroring");

    setTimeout(() => {
      measureWrapper.classList.remove("face-scan-erroring");
    }, 1600);

    return false;
  }

  const properties = {
    _choice: document.querySelector("[name='properties[_choice]']").value,
    _measured_mm: document.querySelector("[name='properties[_measured_mm]']").value,
  };

  return { properties };
};

/* Ausverkaufte Variante: Messknopf und Kontrollkaestchen sperren.
   `nko:variant:change` loest <nko-product-form> aus (assets/product.js);
   die Variante steckt in `detail`. */
document.addEventListener("nko:variant:change", function handleVariantChange(e) {
  const variant = e.detail && e.detail.variant;
  const btn = document.querySelector(".face-scan__measure-btn");
  const input = document.querySelector(".face-width-controls");
  if (!btn || !input) return;
  if (variant && variant.available) {
    btn.removeAttribute("disabled");
    input.classList.remove("disabled");
  } else {
    btn.setAttribute("disabled", "disabled");
    input.classList.add("disabled");
  }
});

// Testlaeufe (page.face-measurement-testing) geben ihre Kennung per URL mit.
if (new URLSearchParams(location.search).has("test_id")) {
  localStorage.setItem("face_app_test_id", new URLSearchParams(location.search).get("test_id"));
}

/* ------------------------------------------------------------------ Lader */

let laden = null; // Promise des Moduls face-scan.js
let gestartet = null; // .face-scan-container, fuer den starte() lief

function ladefehler() {
  delete window.Shopify.FaceScan.handleAtc;
  if (document.querySelector(`.popup--${POPUP}.is-shown`)) window.theme?.popupApp?.clear();
  const hinweis = document.querySelector("[data-face-scan-load-error]");
  if (hinweis) hinweis.hidden = false;
}

function holen() {
  const behaelter = document.querySelector(".face-scan-container[data-module-url]");
  if (!behaelter) return Promise.resolve();
  laden ||= import(behaelter.dataset.moduleUrl).catch((fehler) => {
    laden = null;
    ladefehler();
    throw fehler;
  });
  /* `starte()` genau einmal je Block. Auf der Storefront ist das einmal je
     Seite (der Block ueberlebt jeden Variantenwechsel); im Theme-Editor steht
     nach dem Neurendern ein neuer Block da, und der bekommt seinen eigenen
     Lauf. */
  return laden.then((modul) => {
    const aktuell = document.querySelector(".face-scan-container");
    if (aktuell && aktuell !== gestartet) {
      gestartet = aktuell;
      /* Wirft der Start (Popup-Markup fehlt o. ae.), gilt dasselbe wie bei
         einem Ladefehler — vorher fehlte dann `handleAtc`, weil die App
         vor dessen Zeile abbrach. */
      try {
        modul.starte();
      } catch (fehler) {
        ladefehler();
        throw fehler;
      }
    }
  });
}

/* Vorladen, sobald ein Messknopf Zeiger oder Fokus bekommt — bis Anleitung
   gelesen und weitergeklickt ist, ist die Messung dann laengst da. Auf
   Touchgeraeten kommt `pointerover` mit dem Antippen, also zusammen mit dem
   Oeffnen. */
const vorladen = (e) => {
  if (e.target.closest?.(`[data-popup="${POPUP}"]`)) holen().catch(() => {});
};
document.addEventListener("pointerover", vorladen, { passive: true });
document.addEventListener("focusin", vorladen);

/* assets/popup.js meldet jedes Oeffnen mit `popupOpen:face-scan-app`. Der
   Startschritt kommt hier SOFORT, nicht erst mit face-scan.js: das Markup
   steht auf "choose", und bis das Modul da ist, saehe man sonst kurz die
   Groessenwahl statt der Einleitung. Beim ersten Mal holt face-scan.js den
   Rest (MediaPipe vorwaermen) selbst nach. */
document.body.addEventListener(`popupOpen:${POPUP}`, () => {
  const schritt = document.querySelector(`.popup--${POPUP} [data-curr-step]`);
  if (schritt) schritt.dataset.currStep = "intro";
  holen().catch(() => {});
});

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.
   Module laufen wie `defer` nach dem Parsen in Dokumentreihenfolge, aber nur
   einmal je URL und im strict mode. Dieses steht im Formular-Block VOR
   assets/product.js; `handleAtc` gibt es also, bevor der erste Kauf geht.
   ---------------------------------------------------------------------------- */
